export default __webpack_public_path__ + "static/media/icon-cost.44572feb.svg";